import { Link } from 'react-router';
import { CustomMenu, CustomMenuItem } from '@common/menus/custom-menu';
import { useSettings } from '@ui/settings/use-settings';

export function AuthLayoutFooter() {
  const { branding } = useSettings();
  return (
    <div className="mt-auto flex items-center gap-30 pb-32 pt-42 text-sm text-muted">
      <span>
        © 2026 Impidium LTDA. Todos os direitos reservados.
      </span>
      <CustomMenu
        menu="auth-page-footer"
        orientation="horizontal"
        itemClassName="hover:text-fg-base transition-colors"
      >
        {(item, props) => {
          const modifiedItem =
            item.label === 'Termos e Condições' ||
              item.label === 'Terms and Conditions'
              ? { ...item, action: 'https://impidium.com/#termos', type: 'link' }
              : item;
          return <CustomMenuItem {...props} item={modifiedItem as any} />;
        }}
      </CustomMenu>
    </div>
  );
}
